export default (context, inject) => {
  const WFP2 = () => {
    return new window.Wayforpay()
  }
  inject('WFP2', WFP2)
}
